import EventsSection from "../components/EventsSection";

export default function EventsPage() {
  return (
    <main data-testid="events-page" className="pt-28 min-h-screen bg-white">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16 pt-16 pb-8">
        <span className="eyebrow">— The Calendar</span>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl mt-4 leading-tight text-ink">
          DC Rooftop Events &amp; <span className="text-gold">Nightlife Calendar</span>
        </h1>
        <p className="text-muted max-w-xl mt-4">Friday nights, Saturday signature events, Sunday day parties, and a curated lineup of holiday & celebrity moments.</p>
      </div>
      <EventsSection limit={60} />
    </main>
  );
}
